import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { AuditOverviewService } from 'src/app/services/Audit/audit-overview.service';
import { ProjectDetailModel } from './project-detail.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectStatusModel } from 'src/app/views/Audit/project-overview/models/project-status.model';
import { FinalReviewRatingModel } from 'src/app/views/Audit/project-overview/models/final-review-rating.model';
import { AuditSharedService } from 'src/app/services/Audit/audit-shared.service';
import { ToastrService } from 'ngx-toastr';
import { ProjectDetailConstant } from 'src/app/views/Audit/project-overview/project-detail.constant';
import { AuditdetailsserviceService } from 'src/app/views/Audit/creation/auditor-details/auditdetailsservice.service';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { MatDialog } from '@angular/material/dialog';
// import { CommentsHistoryDialogComponent } from '../comments-history-dialog/comments-history-dialog/comments-history-dialog.component';
import { DatePipe } from '@angular/common'
import { CommentsHistoryDialogComponent } from '../comments-history-dialog/comments-history-dialog.component';

interface AuditDetails {
  teamSize: number;
}
export const STATUS_MAP: { [key: number]: string } = {
  1: "1-Audit Initiated",
  2: "2-Waiting For Manager Approval",
  3: "3-Manager Rejected Audit",
  4: "4-Audit Scheduled",
};
@Component({
  selector: 'app-project-detail',
  templateUrl: './project-detail.component.html',
  styleUrls: ['./project-detail.component.css']
})

export class ProjectDetailComponent implements OnInit {
  private _CONSTATNTS: ProjectDetailConstant;
  @Input() public auditId: number = 0;
  @Input() public selectedProjectStatusId: any;  //Can remove this.
  @Input() public selectedProjectStatusDescription: String;
  @Input() public isFromAudit: boolean = false;

  projectDetail: ProjectDetailModel;
  projectCurrentStatus: ProjectStatusModel;
  finalReviewRating: FinalReviewRatingModel;
  // projectStatusList: Array<ProjectStatusModel> = [];
  parsedDate: Date;
  // filteredStatusList: ProjectStatusModel[] = [];
  isOverviewPage: boolean = true;
  hideSummaryFields: boolean = false;
  showMoreDetailsLink: boolean = false;
  auditorId: number = 0;
  // isAuditor: boolean = false;
  // openHistoryPopUp : boolean = false;
  // showCommentsHistroyButton : boolean = false;
  noOfdaysLeftToCompleteTheAudit: number;

  constructor(private auditOverviewService: AuditOverviewService, private toasterService: ToastrService, private auditDetailService: AuditdetailsserviceService,
    private auditSharedService: AuditSharedService,public datepipe: DatePipe, private router: Router, private route: ActivatedRoute,private dialog : MatDialog) {
    this._CONSTATNTS = new ProjectDetailConstant()
  }


  ngOnInit(): void {
    this.getAuditorId();
    // this.getProjectStatusList();
    this.getProjectDetail();
    // this.isAuditorLoggedIn();
    if (this.router.url === "/Home/Audit/Audit%20Overview" || this.router.url === "/Home/Audit/Auditor%20Detail/Audit%20Overview") {
      this.showMoreDetailsLink = true;
  } else {
      this.showMoreDetailsLink = false;
  }
  }

  // getStatusDescription(selectedProjectStatusId: number): string {
  //   const selectedstatus = this.projectStatusList.find(x=> x.statusId == selectedProjectStatusId);
  //   if(selectedstatus){
  //     this.showCommentsHistroyButton = (selectedProjectStatusId >= 6)
  //     return selectedstatus.description;
  //   }
  //   else{
  //     return 'Unknown Status';
  //   }
  // }
  getProjectDetail() {
    this.auditId = parseInt(localStorage.getItem('AuditId'));
    if (this.auditId > 0) {
        this.auditOverviewService.getProjectDetails(this.auditId).subscribe(
            (responseData: ProjectDetailModel) => { 
                this.projectDetail = responseData;
                this.noOfdaysLeftToCompleteTheAudit = this.daysLeft(responseData.endDate);
                // if (!this.selectedProjectStatusId) {
                //   const projectdetailStatus = this.filteredStatusList.find(item => item.description === responseData.status);
                //   if (projectdetailStatus) {
                //       this.selectedProjectStatusId = projectdetailStatus.statusId;
                //   }
              // }
                // const filter_id: number = 10; // Always 10 as per DB
                // this.projectDetail.pointOfContactName = this.projectDetail.pointOfContacts?.find(item => item.id === filter_id)?.name;   
                this.projectDetail.technologyStack= this.projectDetail.technologyStacksEntities?.map(entity => entity.name).join(', '); 
            },
            (error) => { 
            },
            () => {

            }
        );
    }
}

navigateToEditPage(): void {
  this.auditDetailService.getAuditInfoByAuditId(this.auditId).subscribe((moreProjectDetails: AuditDetails) => {
    const teamSize = moreProjectDetails.teamSize;
    this.auditOverviewService.setHideSummaryFields(true);
   if (teamSize > 0) {
      this.router.navigate(['Home/Audit/Auditor Detail/Audit Overview', this.auditId]);
    } else {
      this.router.navigate(['Home/Audit/Auditor Detail/Audit Overview/', this.auditId]);
    }
  });
}




  // getProjectStatusList() {
  //   this.auditOverviewService.getProjectStatusList().subscribe(
  //     (responseData: ProjectStatusModel[]) => {
  //       this.projectStatusList = responseData;
  //       this.filteredStatusList = this.projectStatusList.filter(item => item.description !== 'Reviewer Assigned');
  //     },
  //     (error) => {
  //       const errorMessage = `Error while fetching project status list: `;
  //     }
  //   );
  // }
  // onStatusChange() {
  //   this.auditOverviewService.setSelectedStatusId(this.selectedProjectStatusId);
  //   this.saveStatusChange();
  // }
  // saveStatusChange() {
  //   this.auditOverviewService.setSelectedStatusId(this.selectedProjectStatusId);
  //   this.auditOverviewService.saveAuditStatus(this.auditId, this.selectedProjectStatusId).subscribe(
  //     (responseData: any) => {
  //       this.toasterService.success('Status submitted successfully!');
  //     },
  //     (error) => {
  //       this.toasterService.error(this._CONSTATNTS.SAVE_ASSIGNEE_API_ERROR, error);
  //     }
  //   );
  // }

  // getStatus(auditId: number) {
  //   this.auditOverviewService.getFinalReviewRating(auditId).subscribe(
  //     (responseStatusData: FinalReviewRatingModel) => {
  //       if (responseStatusData.status === undefined) {
  //         this.selectedProjectStatusId = 0;
  //       }
  //       if (responseStatusData) {
  //         this.selectedProjectStatusId = responseStatusData[0]?.status;
  //       }
  //     },
  //     (error) => {
  //     }
  //   );
  // }

  getAuditorId = () => {
    //Retrieve auditId which is set by Audit Creation Page
    this.auditOverviewService.getAuditorId().subscribe((_auditId: number) => this.auditId = _auditId);
    this.auditorId_MaintainState();
  }

  auditorId_MaintainState = () => {
    //Maintain state of auditId
    if (this.auditorId > 0) {
      localStorage.setItem('AuditorId', this.auditorId?.toString());
    }

    if (this.auditorId < 1) {
      const id = parseInt(localStorage.getItem('AuditorId'));
      this.auditorId = (!isNaN(id)) ? id : this.auditorId;
    }
  }

  auditorId_DestroyState = () => {
    localStorage.removeItem('AuditorId');
  }


  // isAuditorLoggedIn() {
  //   if (parseInt(localStorage.getItem('AuditorId')) == parseInt(localStorage.getItem('Id'))) {
  //     this.isAuditor = false;
  //   }
  //   else {
  //     this.isAuditor = true;
  //   }
  // }

  openOrCloseHistoryPopUp(){
    this.dialog.open(CommentsHistoryDialogComponent,
      {
       data : {auditId : this.auditId,
       statusId : this.projectDetail.statusId
       },
       disableClose: true,
       width : '50%',
      })
      
  }

  daysLeft(targetDate: Date): number {
    const targetDateGivenInString = this.datepipe.transform(targetDate, 'yyyy-MM-dd');
    const givenTargetDate = new Date(targetDateGivenInString);
    const today = new Date();
    const timeDiff =  givenTargetDate.getTime() - today.getTime();
    const days = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return days;
  }
}